import { render, staticRenderFns } from "./welcomeTemplate.vue?vue&type=template&id=0009f12c"
import script from "./welcomeTemplate.vue?vue&type=script&lang=js"
export * from "./welcomeTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports